import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UploadButton from "@rpldy/upload-button";
import Uploady, { Batch, BatchItem, UPLOADER_EVENTS } from "@rpldy/uploady";
import { useSystemAuthState } from "auth/SystemAuth/context/context";
import axios, { AxiosError } from "axios";
import { useAppDispatch } from "hooks/redux";
import { useMemo } from "react";
import { showApiErrorMessage, showErrorMessage } from "store/errorModalSlice";
import { setAttachments } from "store/rfiSlice";
import { setVendorAttachments } from "store/vendorResponseSlice";
import { Attachment, AttachmentType } from "types/RfiTypes";
import UploadList from "./UploadList";

interface IFileUploadProps {
  attachmentType: AttachmentType;
  rfiId: number;
  vendorResponseId?: number;
  elementId?: number;
  elementLabel?: string;
  setElementAttachments?: (attachments: Attachment[]) => void;
}

export default function FileUpload(props: IFileUploadProps) {
  // Hookes
  const dispatch = useAppDispatch();
  const authState = useSystemAuthState();

  // Listeners
  const listeners = useMemo(
    () => ({
      [UPLOADER_EVENTS.BATCH_START]: (batch: Batch) => {
        // console.log(
        //   `Batch Start - ${batch.id} - item count = ${batch.items.length}`
        // );
      },
      [UPLOADER_EVENTS.BATCH_FINISH]: (batch: Batch) => {
        // console.log(
        //   `Batch Finish - ${batch.id} - item count = ${batch.items.length}`
        // );

        axios
          .get(`/api/v1/rfi/${props.rfiId}/Attachments`, {
            params: {
              attachmentType: props.attachmentType,
              vendorResponseId: props.vendorResponseId,
              elementId: props.elementId,
            },
          })
          .then((res) => {
            switch (props.attachmentType) {
              case AttachmentType.RFI:
                dispatch(setAttachments(res.data));
                break;
              case AttachmentType.VENDOR_RESPONSE:
                dispatch(setVendorAttachments(res.data));
                break;
              case AttachmentType.ELEMENT:
                if (props.setElementAttachments) {
                  props.setElementAttachments(res.data);
                } else {
                  dispatch(
                    showErrorMessage(`There was an error uploading attachments`)
                  );
                }
                break;
              default:
                dispatch(
                  showErrorMessage(`There was an error uploading attachment`)
                );
            }
            return res.data;
          })
          .catch((error: Error | AxiosError) => {
            console.log(error);
            dispatch(showApiErrorMessage({ errorResponse: error }));
          });
      },
      [UPLOADER_EVENTS.ITEM_START]: (item: BatchItem) => {
        //console.log(`Item Start - ${item.id} : ${item.file.name}`);
      },
      [UPLOADER_EVENTS.ITEM_FINISH]: (item: BatchItem) => {
        //console.log(`Item Finish - ${item.id} : ${item.file.name}`);
      },
    }),
    []
  );

  // Render
  return (
    <Uploady
      autoUpload={false}
      listeners={listeners}
      destination={{
        url: `/api/v1/Rfi/${props.rfiId}/Attachments`,
        headers: { Authorization: `Bearer ${authState.token}` },
        params: {
          rfiId: props.rfiId,
          attachmentType: props.attachmentType,
          vendorResponseId: props.vendorResponseId,
          elementId: props.elementId,
        },
      }}
      withCredentials
      inputFieldName="files"
      clearPendingOnAdd={false}
    >
      <div>
        {props.elementId && props.elementId > 0 ? (
          // Element Attachments
          <UploadButton
            className="btn btn-outline-primary"
            aria-label={`Upload Attachments for ${
              props.elementLabel ?? "this element"
            }`}
          >
            <i className="fa fa-file-upload" style={{ fontSize: "2.0rem" }} />
          </UploadButton>
        ) : (
          // General Attachments
          <UploadButton
            className="add-Attachment-button"
            aria-label={`General attachments`}
          >
            <FontAwesomeIcon
              icon={faArrowUpFromBracket}
              style={{ color: "#224358" }}
            />
            <span> Add Attachment</span>
          </UploadButton>
        )}
        <UploadList {...props} />
      </div>
    </Uploady>
  );
}
